// Draws a red counter badge over the dashboard favicon so that operators can
// see unassigned conversations even in a regular browser tab (fallback for
// browsers without Badging API support).
const FAVICON_SIZE = 32;
const BADGE_COLOR = '#E5484D';
const TEXT_COLOR = '#FFFFFF';

let originalHrefs = null;

const getFaviconLinks = () => document.querySelectorAll('link.favicon');

const cacheOriginalHrefs = () => {
  if (originalHrefs) return;
  originalHrefs = Array.from(getFaviconLinks()).map(link =>
    link.getAttribute('href')
  );
};

export const resetFavicon = () => {
  if (!originalHrefs) return;
  Array.from(getFaviconLinks()).forEach((link, index) => {
    link.setAttribute('href', originalHrefs[index] || originalHrefs[0]);
  });
};

const buildBadgedFavicon = count =>
  new Promise(resolve => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = FAVICON_SIZE;
      canvas.height = FAVICON_SIZE;
      const context = canvas.getContext('2d');

      context.drawImage(image, 0, 0, FAVICON_SIZE, FAVICON_SIZE);

      const label = count > 99 ? '99+' : String(count);
      const radius = label.length > 1 ? 12 : 10;
      const centerX = FAVICON_SIZE - radius;
      const centerY = radius;

      context.beginPath();
      context.arc(centerX, centerY, radius, 0, Math.PI * 2);
      context.fillStyle = BADGE_COLOR;
      context.fill();

      context.fillStyle = TEXT_COLOR;
      context.font = `bold ${label.length > 1 ? 11 : 13}px sans-serif`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText(label, centerX, centerY + 1);

      resolve(canvas.toDataURL('image/png'));
    };
    image.onerror = () => resolve(null);
    image.src = originalHrefs[0];
  });

export const updateFavicon = async count => {
  cacheOriginalHrefs();
  if (!originalHrefs.length) return;

  if (count <= 0) {
    resetFavicon();
    return;
  }

  const dataUrl = await buildBadgedFavicon(count);
  if (!dataUrl) return;
  getFaviconLinks().forEach(link => link.setAttribute('href', dataUrl));
};
